// Records whose edits are journaled in the `audit_log` table — polymorphic (entity_type + entity_id),
// like `attachments`, so the journal outlives a deleted record.
export const AUDIT_ENTITY_TYPES = {
  IDEA: 'idea',
  PRAISE: 'praise',
  DIRECT_FEEDBACK: 'direct_feedback',
} as const;

export type AuditEntityType = (typeof AUDIT_ENTITY_TYPES)[keyof typeof AUDIT_ENTITY_TYPES];

export const AUDIT_ENTITY_TYPE_VALUES = Object.values(AUDIT_ENTITY_TYPES) as [AuditEntityType, ...AuditEntityType[]];

export const AUDIT_ACTIONS = {
  UPDATE: 'update',
  DELETE: 'delete',
} as const;

export type AuditAction = (typeof AUDIT_ACTIONS)[keyof typeof AUDIT_ACTIONS];

export const AUDIT_ACTION_VALUES = Object.values(AUDIT_ACTIONS) as [AuditAction, ...AuditAction[]];
